// extracted by mini-css-extract-plugin
module.exports = {"container":"k7fYn","triangle":"_1_55p","right":"_1je08","left":"_3zzYR"};